// DarpanRegistration.jsx
import React from "react";

export default function DarpanRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Darpan Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Darpan Registration for NGO Government Recognition
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports NGOs in obtaining Darpan Registration
            for government recognition, grant eligibility, and NITI Aayog unique
            NGO-Darpan ID essential for CSR funding and schemes.
          </p>
          <p className="text-gray-700">
            From NGO-Darpan portal registration and document upload to PAN
            validation, office bearer verification, governing body details, and
            unique ID generation, the process ensures access to government
            schemes and corporate funding opportunities.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: NGO digital registration/government schemes) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3762671/pexels-photo-3762671.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="NGO digital registration for government schemes and Darpan portal"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Darpan Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for NGO-Darpan
              ID generation and government scheme eligibility verification.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>NGO registration certificate (Society/Trust/Section 8 Company).</li>
                <li>PAN card of the NGO organization.</li>
                <li>
                  Office bearer details including Chief Functionary, Secretary,
                  Treasurer PAN, Aadhaar, mobile numbers, and email verification.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in NGO government portal registrations with
              expertise in NITI Aayog compliance requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Government Portal Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete mastery of NGO-Darpan portal, NITI Aayog validation
                  processes, PAN 12-digit linking, and unique ID generation for
                  scheme eligibility.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Documentation Submission
                </h3>
                <p className="text-gray-700 text-sm">
                  Precise document upload, governing body verification, bank
                  account linkage, and compliance declarations ensuring instant
                  Darpan ID generation without rejections.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end NGO enablement from Darpan registration through
                  12A/80G/FCRA integration, CSR portal listing, and government
                  scheme application readiness.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
